import React, {useState} from 'react'
import {
  Content,
  Footer,
  Header
} from './index'
import {authorizeToken} from "../auth/Authorization";
import {withRouter} from "react-router-dom";
import Loader from "react-loader-spinner";
import {getAppBasePath} from "../utils/CommonUtility";

const Layout = (props) => {

  const [loading, isLoading] = useState(true);
  authorizeToken()
  .then(response => {
    isLoading(false);
  })
  .catch(error => {
    console.log("invalid token in Layout screen!", props.history)
    isLoading(false);
    window.location.replace(getAppBasePath());
  });

  return loading ?
    <Loader type="ThreeDots" color="#A6A7AD" height={50} width={50}/> :
    (<div className="c-app c-default-layout">
      <div className="c-wrapper">
        <Header/>
        <div className="c-body">
          <Content/>
        </div>
        <Footer/>
      </div>
    </div>)
}

export default withRouter(Layout);
